// Tu 11 por Encargo — formulario de solicitud dedicado.
// Valida correo (formato + confirmación en tiempo real), teléfono (código de
// país completo + dígitos), talla/manga/nombre/club (obligatorios) y
// personalización (nombre/número condicionales), muestra todos los errores a
// la vez en el submit, y compone contact[body] con los campos estructurados.
(function () {
  var script = document.currentScript;
  if (!script) return;
  var formId = script.getAttribute('data-form-id');
  if (!formId) return;

  var EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  var ERROR_CLASS = 'once-ideal-preorder-form__input--invalid';
  var SHAKE_CLASS = 'once-ideal-preorder-form__input--shake';
  var REQUIRED_MESSAGE = 'Este campo es obligatorio.';

  // Lista completa de países con su código de marcado internacional (E.164 /
  // ITU, datos públicos estándar). México va primero y queda seleccionado
  // por defecto; el resto está ordenado alfabéticamente en español.
  var COUNTRIES = [
    { name: 'México', iso2: 'MX', dial: '+52' },
    { name: 'Afganistán', iso2: 'AF', dial: '+93' },
    { name: 'Albania', iso2: 'AL', dial: '+355' },
    { name: 'Alemania', iso2: 'DE', dial: '+49' },
    { name: 'Andorra', iso2: 'AD', dial: '+376' },
    { name: 'Angola', iso2: 'AO', dial: '+244' },
    { name: 'Anguila', iso2: 'AI', dial: '+1264' },
    { name: 'Antigua y Barbuda', iso2: 'AG', dial: '+1268' },
    { name: 'Arabia Saudita', iso2: 'SA', dial: '+966' },
    { name: 'Argelia', iso2: 'DZ', dial: '+213' },
    { name: 'Argentina', iso2: 'AR', dial: '+54' },
    { name: 'Armenia', iso2: 'AM', dial: '+374' },
    { name: 'Aruba', iso2: 'AW', dial: '+297' },
    { name: 'Australia', iso2: 'AU', dial: '+61' },
    { name: 'Austria', iso2: 'AT', dial: '+43' },
    { name: 'Azerbaiyán', iso2: 'AZ', dial: '+994' },
    { name: 'Bahamas', iso2: 'BS', dial: '+1242' },
    { name: 'Bangladés', iso2: 'BD', dial: '+880' },
    { name: 'Barbados', iso2: 'BB', dial: '+1246' },
    { name: 'Baréin', iso2: 'BH', dial: '+973' },
    { name: 'Bélgica', iso2: 'BE', dial: '+32' },
    { name: 'Belice', iso2: 'BZ', dial: '+501' },
    { name: 'Benín', iso2: 'BJ', dial: '+229' },
    { name: 'Bermudas', iso2: 'BM', dial: '+1441' },
    { name: 'Bielorrusia', iso2: 'BY', dial: '+375' },
    { name: 'Bolivia', iso2: 'BO', dial: '+591' },
    { name: 'Bosnia y Herzegovina', iso2: 'BA', dial: '+387' },
    { name: 'Botsuana', iso2: 'BW', dial: '+267' },
    { name: 'Brasil', iso2: 'BR', dial: '+55' },
    { name: 'Brunéi', iso2: 'BN', dial: '+673' },
    { name: 'Bulgaria', iso2: 'BG', dial: '+359' },
    { name: 'Burkina Faso', iso2: 'BF', dial: '+226' },
    { name: 'Burundi', iso2: 'BI', dial: '+257' },
    { name: 'Bután', iso2: 'BT', dial: '+975' },
    { name: 'Cabo Verde', iso2: 'CV', dial: '+238' },
    { name: 'Camboya', iso2: 'KH', dial: '+855' },
    { name: 'Camerún', iso2: 'CM', dial: '+237' },
    { name: 'Canadá', iso2: 'CA', dial: '+1' },
    { name: 'Catar', iso2: 'QA', dial: '+974' },
    { name: 'Chad', iso2: 'TD', dial: '+235' },
    { name: 'Chile', iso2: 'CL', dial: '+56' },
    { name: 'China', iso2: 'CN', dial: '+86' },
    { name: 'Chipre', iso2: 'CY', dial: '+357' },
    { name: 'Ciudad del Vaticano', iso2: 'VA', dial: '+379' },
    { name: 'Colombia', iso2: 'CO', dial: '+57' },
    { name: 'Comoras', iso2: 'KM', dial: '+269' },
    { name: 'Corea del Norte', iso2: 'KP', dial: '+850' },
    { name: 'Corea del Sur', iso2: 'KR', dial: '+82' },
    { name: 'Costa de Marfil', iso2: 'CI', dial: '+225' },
    { name: 'Costa Rica', iso2: 'CR', dial: '+506' },
    { name: 'Croacia', iso2: 'HR', dial: '+385' },
    { name: 'Cuba', iso2: 'CU', dial: '+53' },
    { name: 'Dinamarca', iso2: 'DK', dial: '+45' },
    { name: 'Dominica', iso2: 'DM', dial: '+1767' },
    { name: 'Ecuador', iso2: 'EC', dial: '+593' },
    { name: 'Egipto', iso2: 'EG', dial: '+20' },
    { name: 'El Salvador', iso2: 'SV', dial: '+503' },
    { name: 'Emiratos Árabes Unidos', iso2: 'AE', dial: '+971' },
    { name: 'Eritrea', iso2: 'ER', dial: '+291' },
    { name: 'Eslovaquia', iso2: 'SK', dial: '+421' },
    { name: 'Eslovenia', iso2: 'SI', dial: '+386' },
    { name: 'España', iso2: 'ES', dial: '+34' },
    { name: 'Estados Unidos', iso2: 'US', dial: '+1' },
    { name: 'Estonia', iso2: 'EE', dial: '+372' },
    { name: 'Esuatini', iso2: 'SZ', dial: '+268' },
    { name: 'Etiopía', iso2: 'ET', dial: '+251' },
    { name: 'Filipinas', iso2: 'PH', dial: '+63' },
    { name: 'Finlandia', iso2: 'FI', dial: '+358' },
    { name: 'Fiyi', iso2: 'FJ', dial: '+679' },
    { name: 'Francia', iso2: 'FR', dial: '+33' },
    { name: 'Gabón', iso2: 'GA', dial: '+241' },
    { name: 'Gambia', iso2: 'GM', dial: '+220' },
    { name: 'Georgia', iso2: 'GE', dial: '+995' },
    { name: 'Ghana', iso2: 'GH', dial: '+233' },
    { name: 'Gibraltar', iso2: 'GI', dial: '+350' },
    { name: 'Granada', iso2: 'GD', dial: '+1473' },
    { name: 'Grecia', iso2: 'GR', dial: '+30' },
    { name: 'Groenlandia', iso2: 'GL', dial: '+299' },
    { name: 'Guadalupe', iso2: 'GP', dial: '+590' },
    { name: 'Guam', iso2: 'GU', dial: '+1671' },
    { name: 'Guatemala', iso2: 'GT', dial: '+502' },
    { name: 'Guayana Francesa', iso2: 'GF', dial: '+594' },
    { name: 'Guernsey', iso2: 'GG', dial: '+44' },
    { name: 'Guinea', iso2: 'GN', dial: '+224' },
    { name: 'Guinea-Bisáu', iso2: 'GW', dial: '+245' },
    { name: 'Guinea Ecuatorial', iso2: 'GQ', dial: '+240' },
    { name: 'Guyana', iso2: 'GY', dial: '+592' },
    { name: 'Haití', iso2: 'HT', dial: '+509' },
    { name: 'Honduras', iso2: 'HN', dial: '+504' },
    { name: 'Hong Kong', iso2: 'HK', dial: '+852' },
    { name: 'Hungría', iso2: 'HU', dial: '+36' },
    { name: 'India', iso2: 'IN', dial: '+91' },
    { name: 'Indonesia', iso2: 'ID', dial: '+62' },
    { name: 'Irak', iso2: 'IQ', dial: '+964' },
    { name: 'Irán', iso2: 'IR', dial: '+98' },
    { name: 'Irlanda', iso2: 'IE', dial: '+353' },
    { name: 'Isla de Man', iso2: 'IM', dial: '+44' },
    { name: 'Islandia', iso2: 'IS', dial: '+354' },
    { name: 'Islas Caimán', iso2: 'KY', dial: '+1345' },
    { name: 'Islas Cook', iso2: 'CK', dial: '+682' },
    { name: 'Islas Feroe', iso2: 'FO', dial: '+298' },
    { name: 'Islas Malvinas', iso2: 'FK', dial: '+500' },
    { name: 'Islas Marshall', iso2: 'MH', dial: '+692' },
    { name: 'Islas Salomón', iso2: 'SB', dial: '+677' },
    { name: 'Islas Turcas y Caicos', iso2: 'TC', dial: '+1649' },
    { name: 'Islas Vírgenes Británicas', iso2: 'VG', dial: '+1284' },
    { name: 'Islas Vírgenes de EE. UU.', iso2: 'VI', dial: '+1340' },
    { name: 'Israel', iso2: 'IL', dial: '+972' },
    { name: 'Italia', iso2: 'IT', dial: '+39' },
    { name: 'Jamaica', iso2: 'JM', dial: '+1876' },
    { name: 'Japón', iso2: 'JP', dial: '+81' },
    { name: 'Jersey', iso2: 'JE', dial: '+44' },
    { name: 'Jordania', iso2: 'JO', dial: '+962' },
    { name: 'Kazajistán', iso2: 'KZ', dial: '+7' },
    { name: 'Kenia', iso2: 'KE', dial: '+254' },
    { name: 'Kirguistán', iso2: 'KG', dial: '+996' },
    { name: 'Kiribati', iso2: 'KI', dial: '+686' },
    { name: 'Kuwait', iso2: 'KW', dial: '+965' },
    { name: 'Laos', iso2: 'LA', dial: '+856' },
    { name: 'Lesoto', iso2: 'LS', dial: '+266' },
    { name: 'Letonia', iso2: 'LV', dial: '+371' },
    { name: 'Líbano', iso2: 'LB', dial: '+961' },
    { name: 'Liberia', iso2: 'LR', dial: '+231' },
    { name: 'Libia', iso2: 'LY', dial: '+218' },
    { name: 'Liechtenstein', iso2: 'LI', dial: '+423' },
    { name: 'Lituania', iso2: 'LT', dial: '+370' },
    { name: 'Luxemburgo', iso2: 'LU', dial: '+352' },
    { name: 'Macao', iso2: 'MO', dial: '+853' },
    { name: 'Macedonia del Norte', iso2: 'MK', dial: '+389' },
    { name: 'Madagascar', iso2: 'MG', dial: '+261' },
    { name: 'Malasia', iso2: 'MY', dial: '+60' },
    { name: 'Malaui', iso2: 'MW', dial: '+265' },
    { name: 'Maldivas', iso2: 'MV', dial: '+960' },
    { name: 'Malí', iso2: 'ML', dial: '+223' },
    { name: 'Malta', iso2: 'MT', dial: '+356' },
    { name: 'Marruecos', iso2: 'MA', dial: '+212' },
    { name: 'Martinica', iso2: 'MQ', dial: '+596' },
    { name: 'Mauricio', iso2: 'MU', dial: '+230' },
    { name: 'Mauritania', iso2: 'MR', dial: '+222' },
    { name: 'Mayotte', iso2: 'YT', dial: '+262' },
    { name: 'Micronesia', iso2: 'FM', dial: '+691' },
    { name: 'Moldavia', iso2: 'MD', dial: '+373' },
    { name: 'Mónaco', iso2: 'MC', dial: '+377' },
    { name: 'Mongolia', iso2: 'MN', dial: '+976' },
    { name: 'Montenegro', iso2: 'ME', dial: '+382' },
    { name: 'Montserrat', iso2: 'MS', dial: '+1664' },
    { name: 'Mozambique', iso2: 'MZ', dial: '+258' },
    { name: 'Namibia', iso2: 'NA', dial: '+264' },
    { name: 'Nauru', iso2: 'NR', dial: '+674' },
    { name: 'Nepal', iso2: 'NP', dial: '+977' },
    { name: 'Nicaragua', iso2: 'NI', dial: '+505' },
    { name: 'Níger', iso2: 'NE', dial: '+227' },
    { name: 'Nigeria', iso2: 'NG', dial: '+234' },
    { name: 'Niue', iso2: 'NU', dial: '+683' },
    { name: 'Noruega', iso2: 'NO', dial: '+47' },
    { name: 'Nueva Caledonia', iso2: 'NC', dial: '+687' },
    { name: 'Nueva Zelanda', iso2: 'NZ', dial: '+64' },
    { name: 'Omán', iso2: 'OM', dial: '+968' },
    { name: 'Países Bajos', iso2: 'NL', dial: '+31' },
    { name: 'Pakistán', iso2: 'PK', dial: '+92' },
    { name: 'Palaos', iso2: 'PW', dial: '+680' },
    { name: 'Palestina', iso2: 'PS', dial: '+970' },
    { name: 'Panamá', iso2: 'PA', dial: '+507' },
    { name: 'Papúa Nueva Guinea', iso2: 'PG', dial: '+675' },
    { name: 'Paraguay', iso2: 'PY', dial: '+595' },
    { name: 'Perú', iso2: 'PE', dial: '+51' },
    { name: 'Polinesia Francesa', iso2: 'PF', dial: '+689' },
    { name: 'Polonia', iso2: 'PL', dial: '+48' },
    { name: 'Portugal', iso2: 'PT', dial: '+351' },
    { name: 'Puerto Rico', iso2: 'PR', dial: '+1787' },
    { name: 'Reino Unido', iso2: 'GB', dial: '+44' },
    { name: 'República Centroafricana', iso2: 'CF', dial: '+236' },
    { name: 'República Checa', iso2: 'CZ', dial: '+420' },
    { name: 'República del Congo', iso2: 'CG', dial: '+242' },
    { name: 'República Democrática del Congo', iso2: 'CD', dial: '+243' },
    { name: 'República Dominicana', iso2: 'DO', dial: '+1809' },
    { name: 'Ruanda', iso2: 'RW', dial: '+250' },
    { name: 'Rumania', iso2: 'RO', dial: '+40' },
    { name: 'Rusia', iso2: 'RU', dial: '+7' },
    { name: 'Samoa', iso2: 'WS', dial: '+685' },
    { name: 'Samoa Americana', iso2: 'AS', dial: '+1684' },
    { name: 'San Cristóbal y Nieves', iso2: 'KN', dial: '+1869' },
    { name: 'San Marino', iso2: 'SM', dial: '+378' },
    { name: 'San Vicente y las Granadinas', iso2: 'VC', dial: '+1784' },
    { name: 'Santa Elena', iso2: 'SH', dial: '+290' },
    { name: 'Santa Lucía', iso2: 'LC', dial: '+1758' },
    { name: 'Santo Tomé y Príncipe', iso2: 'ST', dial: '+239' },
    { name: 'Senegal', iso2: 'SN', dial: '+221' },
    { name: 'Serbia', iso2: 'RS', dial: '+381' },
    { name: 'Seychelles', iso2: 'SC', dial: '+248' },
    { name: 'Sierra Leona', iso2: 'SL', dial: '+232' },
    { name: 'Singapur', iso2: 'SG', dial: '+65' },
    { name: 'Siria', iso2: 'SY', dial: '+963' },
    { name: 'Somalia', iso2: 'SO', dial: '+252' },
    { name: 'Sri Lanka', iso2: 'LK', dial: '+94' },
    { name: 'Sudáfrica', iso2: 'ZA', dial: '+27' },
    { name: 'Sudán', iso2: 'SD', dial: '+249' },
    { name: 'Sudán del Sur', iso2: 'SS', dial: '+211' },
    { name: 'Suecia', iso2: 'SE', dial: '+46' },
    { name: 'Suiza', iso2: 'CH', dial: '+41' },
    { name: 'Surinam', iso2: 'SR', dial: '+597' },
    { name: 'Tailandia', iso2: 'TH', dial: '+66' },
    { name: 'Taiwán', iso2: 'TW', dial: '+886' },
    { name: 'Tanzania', iso2: 'TZ', dial: '+255' },
    { name: 'Tayikistán', iso2: 'TJ', dial: '+992' },
    { name: 'Timor Oriental', iso2: 'TL', dial: '+670' },
    { name: 'Togo', iso2: 'TG', dial: '+228' },
    { name: 'Tonga', iso2: 'TO', dial: '+676' },
    { name: 'Trinidad y Tobago', iso2: 'TT', dial: '+1868' },
    { name: 'Túnez', iso2: 'TN', dial: '+216' },
    { name: 'Turkmenistán', iso2: 'TM', dial: '+993' },
    { name: 'Turquía', iso2: 'TR', dial: '+90' },
    { name: 'Tuvalu', iso2: 'TV', dial: '+688' },
    { name: 'Ucrania', iso2: 'UA', dial: '+380' },
    { name: 'Uganda', iso2: 'UG', dial: '+256' },
    { name: 'Uruguay', iso2: 'UY', dial: '+598' },
    { name: 'Uzbekistán', iso2: 'UZ', dial: '+998' },
    { name: 'Vanuatu', iso2: 'VU', dial: '+678' },
    { name: 'Venezuela', iso2: 'VE', dial: '+58' },
    { name: 'Vietnam', iso2: 'VN', dial: '+84' },
    { name: 'Wallis y Futuna', iso2: 'WF', dial: '+681' },
    { name: 'Yemen', iso2: 'YE', dial: '+967' },
    { name: 'Yibuti', iso2: 'DJ', dial: '+253' },
    { name: 'Zambia', iso2: 'ZM', dial: '+260' },
    { name: 'Zimbabue', iso2: 'ZW', dial: '+263' }
  ];

  function init() {
    var form = document.getElementById(formId);
    if (!form) return;
    if (form.hasAttribute('data-once-ideal-preorder-bound')) return;
    form.setAttribute('data-once-ideal-preorder-bound', '');

    var nameInput = form.querySelector('[data-once-ideal-contact-name]');
    var nameRequiredErrorEl = form.querySelector('[data-once-ideal-contact-name-error]');
    var emailInput = form.querySelector('[data-once-ideal-email]');
    var emailErrorEl = form.querySelector('[data-once-ideal-email-error]');
    var emailConfirmInput = form.querySelector('[data-once-ideal-email-confirm]');
    var emailConfirmErrorEl = form.querySelector('[data-once-ideal-email-confirm-error]');
    var phoneCountrySelect = form.querySelector('[data-once-ideal-phone-country]');
    var phoneDigitsInput = form.querySelector('[data-once-ideal-phone-digits]');
    var phoneHiddenInput = form.querySelector('[data-once-ideal-phone-hidden]');
    var phoneErrorEl = form.querySelector('[data-once-ideal-phone-error]');
    var clubInput = form.querySelector('[data-once-ideal-club]');
    var clubErrorEl = form.querySelector('[data-once-ideal-club-error]');
    var temporadaInput = form.querySelector('[data-once-ideal-temporada]');
    var versionSelect = form.querySelector('[data-once-ideal-version]');
    var tallaSelect = form.querySelector('[data-once-ideal-talla]');
    var tallaErrorEl = form.querySelector('[data-once-ideal-talla-error]');
    var mangaSelect = form.querySelector('[data-once-ideal-manga]');
    var mangaErrorEl = form.querySelector('[data-once-ideal-manga-error]');
    var personalizacionSelect = form.querySelector('[data-once-ideal-personalizacion]');
    var nameFields = form.querySelector('[data-once-ideal-name-fields]');
    var numberFields = form.querySelector('[data-once-ideal-number-fields]');
    var customNameInput = form.querySelector('[data-once-ideal-custom-name]');
    var customNumberInput = form.querySelector('[data-once-ideal-custom-number]');
    var nameErrorEl = form.querySelector('[data-once-ideal-name-error]');
    var numberErrorEl = form.querySelector('[data-once-ideal-number-error]');
    var detallesInput = form.querySelector('[data-once-ideal-detalles]');
    var hiddenBody = form.querySelector('[data-once-ideal-body-hidden]');

    var NAME_MAX = 15;

    function showsName(value) {
      return value === 'Solo nombre' || value === 'Nombre + número';
    }
    function showsNumber(value) {
      return value === 'Solo número' || value === 'Nombre + número';
    }

    // --- Shared error / shake helpers (single implementation reused by every field) ---
    function triggerShake(el) {
      if (!el) return;
      el.classList.remove(SHAKE_CLASS);
      // Force reflow so the animation can restart if it was already applied.
      void el.offsetWidth;
      el.classList.add(SHAKE_CLASS);
      el.addEventListener('animationend', function handler() {
        el.classList.remove(SHAKE_CLASS);
        el.removeEventListener('animationend', handler);
      });
    }

    function setFieldError(el, errorEl, message) {
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
      if (el) {
        var wasInvalid = el.classList.contains(ERROR_CLASS);
        el.classList.add(ERROR_CLASS);
        if (!wasInvalid) triggerShake(el);
      }
    }

    function clearFieldError(el, errorEl) {
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (el) el.classList.remove(ERROR_CLASS);
    }

    function validateRequiredField(el, errorEl, message) {
      if (!el) return true;
      var value = el.value ? el.value.trim() : '';
      if (value === '') {
        setFieldError(el, errorEl, message || REQUIRED_MESSAGE);
        return false;
      }
      clearFieldError(el, errorEl);
      return true;
    }

    // --- Country select: populate from the full COUNTRIES list ---
    function populateCountrySelect() {
      if (!phoneCountrySelect) return;
      phoneCountrySelect.innerHTML = '';
      for (var i = 0; i < COUNTRIES.length; i++) {
        var c = COUNTRIES[i];
        var opt = document.createElement('option');
        opt.value = c.dial;
        opt.textContent = c.name + ' (' + c.dial + ')';
        opt.setAttribute('data-iso2', c.iso2);
        if (i === 0) opt.selected = true; // México is always index 0
        phoneCountrySelect.appendChild(opt);
      }
    }
    populateCountrySelect();

    // --- Personalización visibility ---
    function updatePersonalizacionVisibility() {
      if (!personalizacionSelect) return;
      var value = personalizacionSelect.value;
      if (nameFields) nameFields.hidden = !showsName(value);
      if (numberFields) numberFields.hidden = !showsNumber(value);
      if (!showsName(value)) clearFieldError(customNameInput, nameErrorEl);
      if (!showsNumber(value)) clearFieldError(customNumberInput, numberErrorEl);
    }

    if (personalizacionSelect) {
      personalizacionSelect.addEventListener('change', updatePersonalizacionVisibility);
      updatePersonalizacionVisibility();
    }

    // --- Email (single implementation, reused by input/blur listeners and submit) ---
    function validateEmailField() {
      var raw = emailInput ? emailInput.value.trim() : '';
      if (raw === '') {
        setFieldError(emailInput, emailErrorEl, REQUIRED_MESSAGE);
        return false;
      }
      if (!EMAIL_PATTERN.test(raw)) {
        setFieldError(emailInput, emailErrorEl, 'Ingresa un correo electrónico válido (ej. nombre@dominio.com).');
        return false;
      }
      clearFieldError(emailInput, emailErrorEl);
      return true;
    }

    function validateEmailConfirmField() {
      var raw = emailConfirmInput ? emailConfirmInput.value.trim() : '';
      var emailRaw = emailInput ? emailInput.value.trim() : '';
      if (raw === '') {
        setFieldError(emailConfirmInput, emailConfirmErrorEl, REQUIRED_MESSAGE);
        return false;
      }
      if (raw !== emailRaw) {
        setFieldError(emailConfirmInput, emailConfirmErrorEl, 'Los correos electrónicos no coinciden.');
        return false;
      }
      clearFieldError(emailConfirmInput, emailConfirmErrorEl);
      return true;
    }

    if (emailInput) {
      emailInput.addEventListener('input', function () {
        if (emailInput.classList.contains(ERROR_CLASS) && emailInput.value.trim() !== '') {
          validateEmailField();
        } else if (emailInput.value.trim() !== '') {
          clearFieldError(emailInput, emailErrorEl);
        }
        // Re-check confirmation live whenever the original email changes.
        if (emailConfirmInput && emailConfirmInput.value.trim() !== '') {
          validateEmailConfirmField();
        }
      });
      emailInput.addEventListener('blur', validateEmailField);
    }

    if (emailConfirmInput) {
      emailConfirmInput.addEventListener('input', function () {
        if (emailConfirmInput.value.trim() === '') {
          clearFieldError(emailConfirmInput, emailConfirmErrorEl);
          return;
        }
        validateEmailConfirmField();
      });
      emailConfirmInput.addEventListener('blur', validateEmailConfirmField);
    }

    // --- Phone digits (single implementation) ---
    function validatePhoneField() {
      var raw = phoneDigitsInput ? phoneDigitsInput.value.trim() : '';
      if (raw === '') {
        setFieldError(phoneDigitsInput, phoneErrorEl, REQUIRED_MESSAGE);
        return false;
      }
      if (!/^[0-9]+$/.test(raw)) {
        setFieldError(phoneDigitsInput, phoneErrorEl, 'El número solo puede contener dígitos (sin espacios, letras ni símbolos).');
        return false;
      }
      if (raw.length < 7 || raw.length > 15) {
        setFieldError(phoneDigitsInput, phoneErrorEl, 'El número debe tener entre 7 y 15 dígitos.');
        return false;
      }
      clearFieldError(phoneDigitsInput, phoneErrorEl);
      return true;
    }

    if (phoneDigitsInput) {
      phoneDigitsInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '').slice(0, 15);
        if (this.value.trim() !== '') clearFieldError(phoneDigitsInput, phoneErrorEl);
      });
      phoneDigitsInput.addEventListener('blur', validatePhoneField);
    }

    // --- Manga ---
    function validateMangaField() {
      if (!mangaSelect) return true;
      if (!mangaSelect.value) {
        setFieldError(mangaSelect, mangaErrorEl, 'Selecciona un tipo de manga.');
        return false;
      }
      clearFieldError(mangaSelect, mangaErrorEl);
      return true;
    }
    if (mangaSelect) {
      mangaSelect.addEventListener('change', validateMangaField);
    }

    // --- Contact name / club / talla (generic required fields) ---
    if (nameInput) {
      nameInput.addEventListener('input', function () {
        if (nameInput.value.trim() !== '') clearFieldError(nameInput, nameRequiredErrorEl);
      });
      nameInput.addEventListener('blur', function () {
        validateRequiredField(nameInput, nameRequiredErrorEl);
      });
    }
    if (clubInput) {
      clubInput.addEventListener('input', function () {
        if (clubInput.value.trim() !== '') clearFieldError(clubInput, clubErrorEl);
      });
      clubInput.addEventListener('blur', function () {
        validateRequiredField(clubInput, clubErrorEl);
      });
    }
    if (tallaSelect) {
      tallaSelect.addEventListener('change', function () {
        validateRequiredField(tallaSelect, tallaErrorEl);
      });
    }

    // --- Personalización: nombre en playera (máx. 15 caracteres reales) ---
    function validateCustomNameField() {
      var raw = customNameInput ? customNameInput.value.trim() : '';
      if (raw === '') {
        setFieldError(customNameInput, nameErrorEl, REQUIRED_MESSAGE);
        return false;
      }
      if (raw.length > NAME_MAX) {
        setFieldError(customNameInput, nameErrorEl, 'El nombre debe tener ' + NAME_MAX + ' caracteres o menos.');
        return false;
      }
      clearFieldError(customNameInput, nameErrorEl);
      return true;
    }

    if (customNameInput) {
      customNameInput.addEventListener('input', function () {
        // Enforce the limit for real, not just via the maxlength placeholder.
        if (this.value.length > NAME_MAX) {
          this.value = this.value.slice(0, NAME_MAX);
        }
        if (this.value.trim() !== '') clearFieldError(customNameInput, nameErrorEl);
      });
      customNameInput.addEventListener('blur', validateCustomNameField);
    }

    // --- Personalización: número (0–999), robusto contra letras/símbolos/paste ---
    function filterNumericValue(el) {
      var digits = el.value.replace(/[^0-9]/g, '').slice(0, 3);
      // Belt-and-suspenders: a 3-digit string can never exceed 999, but keep
      // an explicit numeric guard in case this function is ever reused
      // elsewhere with a different max length.
      if (digits !== '' && parseInt(digits, 10) > 999) {
        digits = digits.slice(0, digits.length - 1);
      }
      el.value = digits;
    }

    function validateCustomNumberField() {
      var raw = customNumberInput ? customNumberInput.value.trim() : '';
      if (raw === '') {
        setFieldError(customNumberInput, numberErrorEl, REQUIRED_MESSAGE);
        return false;
      }
      if (!/^[0-9]{1,3}$/.test(raw) || parseInt(raw, 10) > 999) {
        setFieldError(customNumberInput, numberErrorEl, 'Ingresa un número válido (0–999).');
        return false;
      }
      clearFieldError(customNumberInput, numberErrorEl);
      return true;
    }

    if (customNumberInput) {
      // Primary, cross-platform guarantee: the 'input' event fires after any
      // value change — typed key, IME, autofill, drag-drop or paste — so
      // stripping non-digits here is what actually blocks letters/symbols on
      // every device, including mobile keyboards where 'keydown' is unreliable.
      customNumberInput.addEventListener('input', function () {
        filterNumericValue(this);
        if (this.value.trim() !== '') clearFieldError(customNumberInput, numberErrorEl);
      });

      // Extra desktop-level guard: block obviously non-numeric keys before
      // they're even inserted (belt-and-suspenders on top of the input filter).
      customNumberInput.addEventListener('keydown', function (e) {
        var allowedKeys = [
          'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
          'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'
        ];
        if (allowedKeys.indexOf(e.key) !== -1) return;
        if (e.ctrlKey || e.metaKey) return; // allow copy/paste/select-all shortcuts
        if (!/^[0-9]$/.test(e.key)) {
          e.preventDefault();
        }
      });

      // Explicit paste handling: intercept the paste, strip non-digits from
      // the clipboard text ourselves, and insert only the digits — covers
      // the case even if some environment's 'input' event behaved unexpectedly.
      customNumberInput.addEventListener('paste', function (e) {
        e.preventDefault();
        var clipboard = (e.clipboardData || window.clipboardData);
        var pasted = clipboard ? clipboard.getData('text') : '';
        var digitsOnly = pasted.replace(/[^0-9]/g, '');
        var start = this.selectionStart != null ? this.selectionStart : this.value.length;
        var end = this.selectionEnd != null ? this.selectionEnd : this.value.length;
        this.value = this.value.slice(0, start) + digitsOnly + this.value.slice(end);
        filterNumericValue(this);
        if (this.value.trim() !== '') clearFieldError(customNumberInput, numberErrorEl);
      });

      customNumberInput.addEventListener('blur', validateCustomNumberField);
    }

    function composeBody() {
      var lines = [];
      lines.push('Club o selección: ' + (clubInput ? clubInput.value.trim() : ''));
      lines.push('Temporada / año aproximado: ' + (temporadaInput ? temporadaInput.value.trim() : ''));
      lines.push('Versión: ' + (versionSelect && versionSelect.value ? versionSelect.value : 'No aplica / no especificado'));
      lines.push('Talla: ' + (tallaSelect ? tallaSelect.value : ''));
      lines.push('Manga: ' + (mangaSelect ? mangaSelect.value : ''));
      var personalizacion = personalizacionSelect ? personalizacionSelect.value : '';
      lines.push('Personalización: ' + personalizacion);
      if (showsName(personalizacion)) {
        lines.push('Nombre en la playera: ' + (customNameInput ? customNameInput.value.trim() : ''));
      }
      if (showsNumber(personalizacion)) {
        lines.push('Número: ' + (customNumberInput ? customNumberInput.value.trim() : ''));
      }
      lines.push('');
      lines.push('¿Hay algún detalle más que debamos conocer?');
      lines.push(detallesInput ? detallesInput.value.trim() : '');
      return lines.join('\n');
    }

    // --- Full-form validation: checks every required field, shows ALL
    // errors simultaneously, and returns the invalid elements in DOM order. ---
    function validateForm() {
      var invalidEls = [];
      function check(valid, el) {
        if (!valid && el) invalidEls.push(el);
      }

      check(validateRequiredField(nameInput, nameRequiredErrorEl), nameInput);
      check(validateEmailField(), emailInput);
      check(validateEmailConfirmField(), emailConfirmInput);
      check(validatePhoneField(), phoneDigitsInput);
      check(validateRequiredField(clubInput, clubErrorEl), clubInput);
      check(validateRequiredField(tallaSelect, tallaErrorEl), tallaSelect);
      check(validateMangaField(), mangaSelect);

      var personalizacion = personalizacionSelect ? personalizacionSelect.value : '';
      if (showsName(personalizacion)) {
        check(validateCustomNameField(), customNameInput);
      } else {
        clearFieldError(customNameInput, nameErrorEl);
      }
      if (showsNumber(personalizacion)) {
        check(validateCustomNumberField(), customNumberInput);
      } else {
        clearFieldError(customNumberInput, numberErrorEl);
      }

      return invalidEls;
    }

    form.addEventListener(
      'submit',
      function (evt) {
        var invalidEls = validateForm();

        if (invalidEls.length > 0) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          var firstInvalid = invalidEls[0];
          firstInvalid.focus({ preventScroll: true });
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        if (phoneHiddenInput) {
          var dialCode = phoneCountrySelect ? phoneCountrySelect.value : '';
          phoneHiddenInput.value = dialCode + ' ' + phoneDigitsInput.value.trim();
        }
        if (hiddenBody) hiddenBody.value = composeBody();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
